import React from "react";

import peb1 from "../../assets/polished/polished1.webp";
import peb2 from "../../assets/polished/polished6.webp";
import peb3 from "../../assets/riverpebbelstone/riverpebbles5.webp";
import peb4 from "../../assets/riverpebbelstone/riverstones1.webp";

import f1 from "../../assets/frames/f1.webp";
import f2 from "../../assets/frames/f2.webp";
import f3 from "../../assets/frames/f3.webp";
import f4 from "../../assets/frames/f4.webp";

import b1 from "../../assets/boulders/bould1.webp";
import b2 from "../../assets/boulders/bould4.webp";
import b3 from "../../assets/boulders/bould5.webp";
import b4 from "../../assets/boulders/bould6.webp";

import stat1 from "../../assets/statues/stat1.webp";
import stat2 from "../../assets/statues/stat2.webp";
import stat3 from "../../assets/statues/stat5.webp";
import stat4 from "../../assets/statues/stat6.webp";



import { Link } from "react-router-dom";

function Offerings() {
  return (
    <section className="w-full py-16">
      <h1 className="text-[32px] md:text-[40px] lg:text-[48px] text-transparent bg-clip-text bg-gradient-to-t from-gray-700 to-gray-300 hover:from-gray-300 hover:to-gray-700 font-ten tracking-tight font-extrabold">
        Our Offerings
      </h1>

      <div className="m-auto p-8 space-y-20 lg:w-[80%]">
        {/*pebbels/river stones*/}
        <div className="flex flex-col shadow-md md:shadow-lg  border-2 p-4 rounded-lg lg:flex-row mt-10 gap-8 dark:text-white">
          <div className="relative grid grid-cols-2 gap-[6px] lg:w-[50%] w-full">
            {/* Image 1 */}
            <img
              src={peb1}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 2 */}
            <img
              src={peb2}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 3 */}
            <img
              src={peb3}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 4 */}
            <img
              src={peb4}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
          </div>

          <div className="flex flex-col gap-10 lg:w-[50%] w-full justify-center">
            <div className="font-ten space-y-4 text-[14px] md:text-[16px] font-medium text-left">
              <h3 className="font-bold text-[20px] md:text-[24px]">
                Pebbles and River Stones
              </h3>

              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                We offer a top selection of natural stone elements, including
                <span className="font-bold"> Polished Pebbles </span>
                in Jet Black, Cream, and Mixed Earth Tones,
                <span className="font-bold"> Natural River Cobbles </span>, and
                unique{" "}
                <span className="font-bold"> Decorative Accent Stones</span>.
                Our collection ensures superior aesthetics and reliable bulk
                supply for landscaping, water features, and interior design
                projects.
              </p>
            </div>
            <p className="font-ten text-[14px] ">
              Want to check more about our offerings?{" "}
              <Link
                to="/gallery"
                className="text-blue-500 hover:underline font-semibold"
              >
                Click here
              </Link>
            </p>
          </div>
        </div>

        {/* Art frames */}
        <div className="flex flex-col shadow-md md:shadow-lg  bg-gray-200 dark:bg-gray-800 border-2 p-4 rounded-lg lg:flex-row-reverse mt-10 gap-8 dark:text-white">
          <div className="relative grid grid-cols-2 gap-[6px] lg:w-[50%] w-full">
            {/* Image 1 */}
            <img
              src={f1}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 2 */}
            <img
              src={f2}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 3 */}
            <img
              src={f3}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 4 */}
            <img
              src={f4}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
          </div>

          <div className="flex flex-col gap-10 lg:w-[50%] w-full justify-center">
            <div className="font-ten space-y-4 text-[14px] md:text-[16px] font-medium text-left">
              <h3 className="font-bold text-[20px] md:text-[24px]">
                Pebble Art Frames
              </h3>

              <p className="text-gray-700 flex flex-col dark:text-gray-300 leading-relaxed">
                Bring tranquility and bespoke charm to any interior with our
                exclusive Pebble Art Frames. Every frame features a
                one-of-a-kind stone and natural material composition, offering a
                durable, maintenance-free artistic statement that complements a
                range of design aesthetics.
              </p>
              <p className="text-gray-700 flex flex-col dark:text-gray-300 leading-relaxed">
                You can gift these art frames to your loved ones or
                professionals. We accept custom and bulk orders as well.
              </p>
            </div>

            <p className="font-ten text-[14px] ">
              Want to check more about our offerings?{" "}
              <Link
                to="/gallery"
                className="text-blue-500 hover:underline font-semibold"
              >
                Click here
              </Link>
            </p>
          </div>
        </div>

        {/*limestone boulders*/}
        <div className="flex flex-col shadow-md md:shadow-lg   border-2 p-4 rounded-lg lg:flex-row mt-10 gap-8 dark:text-white">
          <div className="relative grid grid-cols-2 gap-[6px] lg:w-[50%] w-full">
            {/* Image 1 */}
            <img
              src={b1}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 2 */}
            <img
              src={b2}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 3 */}
            <img
              src={b3}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 4 */}
            <img
              src={b4}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
          </div>

          <div className="flex flex-col gap-10 lg:w-[50%] w-full justify-center">
            <div className="font-ten space-y-4 text-[14px] md:text-[16px] font-medium text-left">
              <h3 className="font-bold  text-[20px] md:text-[24px]">
                Lime Stone / Boulders
              </h3>

              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                Elevate your landscape design with the timeless beauty and
                robust presence of our Natural Limestone Boulders. Prized for
                their subtle, earthy tones and naturally textured surfaces,
                these monumental stones offer an unparalleled combination of
                elegance and durability. We also provide flooring-grade
                limestone and parking stones that are perfect for both
                residential and commercial applications.
              </p>
            </div>

            <p className="font-ten text-[14px] ">
              Want to check more about our offerings?{" "}
              <Link
                to="/gallery"
                className="text-blue-500 hover:underline font-semibold"
              >
                Click here
              </Link>
            </p>
          </div>
        </div>

        {/* Statues */}
        <div className="flex flex-col shadow-md md:shadow-lg bg-gray-200 dark:bg-gray-800 border-2 p-4 rounded-lg lg:flex-row-reverse mt-10 gap-8 dark:text-white">
          <div className="relative grid grid-cols-2 gap-[6px] lg:w-[50%] w-full">
            {/* Image 1 */}
            <img
              src={stat1}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 2 */}
            <img
              src={stat2}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 3 */}
            <img
              src={stat3}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
            {/* Image 4 */}
            <img
              src={stat4}
              alt="About Konduti Stones"
              className="w-full h-52 md:h-64 lg:h-72 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
            />
          </div>

          <div className="flex flex-col gap-10 lg:w-[50%] w-full justify-center">
            <div className="font-ten space-y-4 text-[14px] md:text-[16px] font-medium text-left">
              <h3 className="font-bold text-[20px] md:text-[24px]">
                Statues and Sculptures:
              </h3>

              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                Our collection of Natural Stone Statues and Sculptures offers
                more than just decoration — they are three-dimensional
                masterpieces, carved by skilled artisans to bring a focal point
                of sophistication, culture, and permanence to any setting.
              </p>
            </div>

            <p className="font-ten text-[14px] ">
              Want to check more about our offerings?{" "}
              <Link
                to="/gallery"
                className="text-blue-500 hover:underline font-semibold"
              >
                Click here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Offerings;
